import { jsx, jsxs } from "react/jsx-runtime";
import "react";
const LoadMoreIcon = ()=>/*#__PURE__*/ jsxs("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsx("rect", {
                width: "48",
                height: "48",
                rx: "24",
                fill: "#EDF0F3"
            }),
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M25 19H23V23H19V25H23V29H25V25H29V23H25V19Z",
                fill: "#0068EF"
            })
        ]
    });
const LoadMore_LoadMoreIcon = LoadMoreIcon;
export { LoadMore_LoadMoreIcon as default };
